import SubHeader from "../../components/header/SubHeader";
import React, {useEffect} from "react";
import Button from "../../components/common/button/Button";
import Table from "../../components/common/table/Table";
import {useSelector, useDispatch} from "react-redux";
import {fetchAllContact, fetchContactById} from "../../store/contact-slice";
import {getDetailData, getTableColumns, getTableData} from "../../models/contactModel";

const ContactView = () => {
    const dispatch = useDispatch();
    const {
        items,
        fetchStatus,
        error
    } = useSelector(state => state.contact);

    useEffect(() => {
        dispatch(fetchAllContact());
    }, [dispatch]);

    const tableColumns = getTableColumns();
    const tableData = getTableData({items});

    return (
        <>
            <SubHeader title="Contact us">
                <Button to="/" className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>

            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <Table
                    className="mobile-responsive"
                    columns={tableColumns}
                    data={tableData}
                    getDetailData={getDetailData}
                    fetchData={fetchContactById}
                />
            )}
        </>
    )
}

export default ContactView;